import { StyledContainer, StyledDescription, StyledTitle } from './styled';

type HeaderProps = {
  title: string;
  description: string;
};

const Header = ({ title, description }: HeaderProps) => (
  <StyledContainer>
    <StyledTitle>{title}</StyledTitle>
    <StyledDescription>{description}</StyledDescription>
  </StyledContainer>
);

export default Header;
